import { newGraphStep } from './newGraphStep.js';

const validateAddStepToGraphRequest = ({ graph, parentStepId, relation, index }) => {
  if (!['exit', 'child', 'branch'].includes(relation)) {
    throw new Error(`Cannot add step to graph: relation "${relation}" is not supported.`);
  }

  if (['child', 'branch'].includes(relation) && !parentStepId) {
    throw new Error(`Cannot add step to graph: relation "${relation}" requires a parent step.`);
  }

  if (parentStepId && !graph?.[parentStepId]) {
    throw new Error(`Cannot add step to graph: parent step "${parentStepId}" does not exist.`);
  }

  if (relation === 'branch' && (!Number.isInteger(index) || index < 0)) {
    throw new Error('Cannot add step to graph: branch relation requires a non-negative integer index.');
  }
};

export const addStepToGraph = ({ graph, stepId, parentStepId, relation, index, step }) => {
  validateAddStepToGraphRequest({ graph, parentStepId, relation, index });

  const currentParent = {
    ...(parentStepId ? graph[parentStepId] : newGraphStep()),
    branches: Array.isArray(graph?.[parentStepId]?.branches) ? [...graph[parentStepId].branches] : []
  };

  graph[stepId] = step ? { ...step, branches: Array.isArray(step?.branches) ? [...step.branches] : [] } : newGraphStep();

  // If a normal exit node,
  if (relation === 'exit') {
    graph[stepId].exit = currentParent?.exit;
    if (parentStepId) {
      graph[parentStepId].exit = stepId;
    }
  }

  if (relation === 'child') {
    graph[stepId].exit = currentParent.child;
    if (parentStepId) {
      graph[parentStepId].child = stepId;
    }
  }

  if (relation === 'branch') {
    graph[stepId].exit = currentParent?.branches?.[index];
    if (parentStepId) {
      graph[parentStepId].branches = Array.isArray(graph[parentStepId].branches) ? graph[parentStepId].branches : [];
      graph[parentStepId].branches[index] = stepId;
    }
  }

  return graph;
};
